import { useState, useEffect } from "react";
import { Concept1 } from "@/components/concepts/Concept1";
import { Concept2 } from "@/components/concepts/Concept2";
import { Concept3 } from "@/components/concepts/Concept3";

const CONCEPTS = [
  { id: "concept-1", n: "01", name: "Editorial Maison", desc: "Magazine/gallery — oversized serif, whitespace, hairlines. Quiet, couture confidence.", Comp: Concept1 },
  { id: "concept-2", n: "02", name: "Cinematic Lifestyle", desc: "Full-bleed campaign hero kept light & airy, slow Ken-Burns motion, glass detail, brand marquee.", Comp: Concept2 },
  { id: "concept-3", n: "03", name: "Modern Atelier", desc: "Structured editorial bento grid — contemporary luxury with micro-interactions.", Comp: Concept3 },
];

export default function Concepts() {
  const [active, setActive] = useState("concept-1");

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) setActive(e.target.id); }),
      { rootMargin: "-45% 0px -45% 0px" }
    );
    CONCEPTS.forEach((c) => { const el = document.getElementById(c.id); if (el) obs.observe(el); });
    return () => obs.disconnect();
  }, []);

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="min-h-screen bg-[#FFFAF4] font-body text-[#08083a]">
      {/* sticky switcher */}
      <header className="sticky top-0 z-50 border-b border-[#08083a]/10 bg-[#FFFAF4]/85 backdrop-blur-md">
        <div className="container-site flex items-center justify-between gap-4 py-3">
          <div className="flex items-center gap-3">
            <span className="font-display text-lg">Boomerang</span>
            <span className="hidden text-[11px] uppercase tracking-[0.22em] text-[#08083a]/45 sm:inline">Concept Studio</span>
          </div>
          <nav className="flex items-center gap-1">
            {CONCEPTS.map((c) => (
              <button key={c.id} onClick={() => scrollTo(c.id)} data-testid={`concept-nav-${c.n}`}
                className={`rounded-full px-3.5 py-1.5 text-xs font-semibold uppercase tracking-[0.12em] transition-colors duration-200 ${
                  active === c.id ? "bg-[#08083a] text-white" : "text-[#08083a]/60 hover:bg-[#08083a]/8"
                }`}>
                {c.n}
              </button>
            ))}
          </nav>
        </div>
      </header>

      <div className="container-site py-8 text-center">
        <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-[#FE7D01]">Three Directions</p>
        <h1 className="mt-3 font-display text-3xl sm:text-4xl">Luxury identity concepts</h1>
        <p className="mx-auto mt-3 max-w-xl text-sm text-[#08083a]/65">
          Three distinct art directions for the Kentucky Horsewear flagship — all on your brand palette.
          Scroll to compare, then tell me which to take site-wide (or mix elements).
        </p>
      </div>

      {CONCEPTS.map((c) => (
        <section key={c.id} id={c.id} className="scroll-mt-16">
          <div className="container-site flex items-center gap-4 py-6">
            <span className="font-display text-5xl text-[#08083a]/15">{c.n}</span>
            <div>
              <h2 className="font-display text-2xl">{c.name}</h2>
              <p className="max-w-xl text-sm text-[#08083a]/60">{c.desc}</p>
            </div>
          </div>
          <div className="mx-auto max-w-[1400px] overflow-hidden rounded-2xl border border-[#08083a]/12 bg-white shadow-[0_20px_60px_rgba(8,8,64,0.10)]">
            <c.Comp />
          </div>
          <div className="py-10" />
        </section>
      ))}
    </div>
  );
}
